'use strict';


class HistorialModalController {
  constructor(NgTableParams, DataService, Storage, Sidenav, Modal, $log, Util, $uibModalInstance, $filter, data) {
    'ngInject';
    this.NgTableParams = NgTableParams;
    this.DataService = DataService;
    this.Storage = Storage;
    this.Modal = Modal;
    this.Sidenav = Sidenav;
    this.$log = $log;
    this.Util = Util;
    this.$uibModalInstance = $uibModalInstance;
    this.$filter = $filter;
    this.data = data;

  }
  $onInit() {
    this.id_producto = this.data.id_producto;

    this.DataService.get(`certificacion_promueve/${this.id_producto}/historial`)
    .then(response => {
      this.Tiempos = response;
    })

  }


  cancel() {
    this.$uibModalInstance.close();
  }

}

export default HistorialModalController;



// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/ddjj/historial.modal.controller.js